import { Component, OnInit } from '@angular/core';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import * as moment from 'moment';

@Component({
  selector: 'swb-textbox',
  templateUrl: './textbox.component.html'
})
export class TextboxComponent extends FormEditorBase {
  constructor() {
    super();
  }
}
